import { Column } from "../components/report/models/column.model";
import { ReportEntity } from "../components/report/models/report-entity.model";
import { Report } from "../components/report/models/report.model";

export function getEntityByColumn(report : Report, column: Column): ReportEntity {
    return report.Entities.find(x => x.Columns.indexOf(column) !== -1);
}